import Vue from 'vue'
import Popup from './index.vue'
const PopupBox = Vue.extend(Popup)
const Popup1: any = Popup
Popup1.install = function (data: any) {
  const instance = new PopupBox({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  // show 和弹窗组件里的show对应，用于控制显隐
  })
}
export default Popup1
